(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[507],{

/***/ 1999:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service",
      function () {
        return __webpack_require__(1962);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Content_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9756);
/* harmony import */ var _Content_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Content_module_css__WEBPACK_IMPORTED_MODULE_2__);
// import node_modules



// import styles

// define component
var ContentComponent = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content_module_css__WEBPACK_IMPORTED_MODULE_2___default().content),
        dangerouslySetInnerHTML: {
            __html: children
        }
    });
};
ContentComponent.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentComponent);


/***/ }),

/***/ 8325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1151);
/* harmony import */ var _MarkdownImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4022);
/* harmony import */ var _MarkdownLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97);
/* harmony import */ var _Markdown_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7310);
/* harmony import */ var _Markdown_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Markdown_module_css__WEBPACK_IMPORTED_MODULE_4__);
// import node_modules




// import components


// import styles

// define component
var LocalMarkdown = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Markdown_module_css__WEBPACK_IMPORTED_MODULE_4___default().markdown),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mdx_js_react__WEBPACK_IMPORTED_MODULE_5__/* .MDXProvider */ .Zo, {
            components: {
                StorylinerImage: _MarkdownImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                a: _MarkdownLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
            },
            children: children
        })
    });
};
LocalMarkdown.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (LocalMarkdown);


/***/ }),

/***/ 4022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _StorylinerImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4090);
// import node_modules



// import components

// define components
var MarkdownImage = function(param) {
    var height = param.height, hasShadow = param.hasShadow, imageId = param.imageId, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "storyliner-markdown-image",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StorylinerImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
            hasShadow: hasShadow,
            height: height,
            imageId: imageId,
            title: title,
            width: width
        })
    });
};
MarkdownImage.defaultProps = {
    hasShadow: false
};
MarkdownImage.propTypes = {
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownImage);


/***/ }),

/***/ 97:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5676);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__);
// import node_modules




// import types

// define component
var MarkdownLink = function(param) {
    var children = param.children, href = param.href;
    // storyliner link
    if (href === null || href === void 0 ? void 0 : href.includes("https://storylinerlabs.com")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            className: (_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
            href: href.replace("https://storylinerlabs.com", ""),
            passHref: true,
            children: children
        });
    }
    // external link
    if ((href === null || href === void 0 ? void 0 : href.includes("http")) || (href === null || href === void 0 ? void 0 : href.includes("mailto"))) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            rel: "noopener noreferrer",
            target: "_blank",
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: children
        })
    });
};
MarkdownLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownLink);


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorylinerImage": function() { return /* binding */ StorylinerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2848);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable react/jsx-props-no-spreading */ // import node_modules






// import styles

// Define component
var StorylinerImage = function(param) {
    var className = param.className, hasShadow = param.hasShadow, hasWhiteBg = param.hasWhiteBg, height = param.height, imageId = param.imageId, isBlack = param.isBlack, isRounded = param.isRounded, isWhite = param.isWhite, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default().image), isBlack && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-black"]), isWhite && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-white"]), isRounded && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-rounded"]), hasShadow && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["has-shadow"]), hasWhiteBg && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["white-bg"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            alt: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            className: className,
            height: height,
            layout: "responsive",
            loading: "lazy",
            src: imageId,
            title: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            width: width
        })
    });
};
StorylinerImage.defaultProps = {
    className: undefined,
    hasShadow: undefined,
    hasWhiteBg: undefined,
    isBlack: false,
    isRounded: true,
    isWhite: false
};
StorylinerImage.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    hasWhiteBg: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    isBlack: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isRounded: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWhite: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (StorylinerImage);


/***/ }),

/***/ 3192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(603);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7058);
/* harmony import */ var jotai_immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8387);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _modules_jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1262);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4370);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__);
// import node_modules







// import types

// import components

// import modules

// import styles

// define component
var EarlyAccessSection = function(param) {
    var bgColor = param.bgColor;
    // init hooks
    var _useImmerAtom = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,jotai_immer__WEBPACK_IMPORTED_MODULE_7__/* .useImmerAtom */ .It)(_modules_jotai__WEBPACK_IMPORTED_MODULE_5__/* .earlyAccessModalAtom */ .KR), 2), setEarlyAccessModalState = _useImmerAtom[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("components").t;
    // init func
    var onOpenModal = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        setEarlyAccessModalState(function() {
            return true;
        });
    }, [
        setEarlyAccessModalState
    ]);
    // render section
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-header"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                            alignment: "center",
                            isHyphenated: false,
                            tag: "h2",
                            children: t("EarlyAccessSection.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            alignment: "center",
                            children: t("EarlyAccessSection.intro")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-button"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                            color: "dark",
                            text: t("EarlyAccessSection.callToAction.label"),
                            size: "large",
                            onClick: onOpenModal
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-scribble"])
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-helptext-container"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        alignment: "center",
                        isHelpText: true,
                        size: "small",
                        children: t("EarlyAccessSection.creditCard")
                    })
                })
            ]
        })
    });
};
EarlyAccessSection.defaultProps = {
    bgColor: "white"
};
EarlyAccessSection.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_10__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .SectionColorEnum */ .TJ))
};
/* harmony default export */ __webpack_exports__["default"] = (EarlyAccessSection);


/***/ }),

/***/ 1962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1151);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4468);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _components_atoms_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4992);
/* harmony import */ var _components_atoms_Content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(319);
/* harmony import */ var _components_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3192);
/* harmony import */ var _components_atoms_LocalMarkdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8325);
/* harmony import */ var _components_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6880);
/* harmony import */ var _components_meta_SEO__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8897);
/* harmony import */ var _components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9748);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8362);
/*@jsxRuntime automatic @jsxImportSource react*/ /*import node_modules*/ /*import types*/ /*import components*/ /*import config*/ /*define layout*/ /*Navbar*/ /*define content*/ 











var MDXLayout = function(param) {
    var children = param.children;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_SEO__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                description: "Terms of service of Storyliner Labs GmbH. Read now …",
                hrefLang: _types__WEBPACK_IMPORTED_MODULE_2__/* .RouteEnum.WEBSITE_TERMS_OF_SERVICE_DE */ .gv.WEBSITE_TERMS_OF_SERVICE_DE,
                image: "".concat(_config__WEBPACK_IMPORTED_MODULE_10__/* .storylinerRootDomain */ .pk, "/img/screensavers/screensaver-break-creative-barriers-storyliner.jpg"),
                title: "Terms of service - Storyliner"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "64px"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "50px"
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    cols: "md",
                    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_LocalMarkdown__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: children
                    })
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "50px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                bgColor: "desertStorm",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "100px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_5__["default"], {
                bgColor: "desertStorm"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                bgColor: "desertStorm",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "100px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "50px"
                })
            })
        ]
    });
};
function _createMdxContent(props) {
    var _components = Object.assign({
        h1: "h1",
        p: "p"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_11__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h1, {
                children: "Terms of Service"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "The terms of Servcie are being revised and will be available again soon. Please come back later …"
            })
        ]
    });
}
function MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ }),

/***/ 9756:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"storyliner-CKbkg8","responsive-iframe":"storyliner-7RxrfO","iframe-wrapper":"storyliner-Gja7zP","optin-canvas":"storyliner-hrBBek","info-text":"storyliner-FMSQUL","icon-wrapper":"storyliner-JVx0j2","optin-button":"storyliner-iD5V57"};

/***/ }),

/***/ 7310:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"storyliner-l9a5zk","storyliner-markdown-button":"storyliner-5WQeFL","storyliner-markdown-image":"storyliner-0CMuRb","responsive-iframe":"storyliner-MQtvxX","iframe-wrapper":"storyliner-s6HK1y","optin-canvas":"storyliner-xzbQ5J","info-text":"storyliner-xynJAU","icon-wrapper":"storyliner-HYoR1F","optin-button":"storyliner-0o3hOL"};

/***/ }),

/***/ 5676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"storyliner-ttPbzh"};

/***/ }),

/***/ 2848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"storyliner-vbD9mK","fade-in":"storyliner-eNwawO","is-rounded":"storyliner-kV1a7W","is-white":"storyliner-FVEYZh","is-black":"storyliner-dc3Q7B","has-shadow":"storyliner-QcsozF","white-bg":"storyliner-bi4CsT"};

/***/ }),

/***/ 4370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storyliner-early-access-section":"storyliner-wwGQfR","storyliner-early-access-section-header":"storyliner-idzssv","storyliner-early-access-button":"storyliner-oIUwVo","storyliner-early-access-scribble":"storyliner-gRgBcx","storyliner-early-access-section-helptext-container":"storyliner-VU7xmS"};

/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NF": function() { return /* binding */ withMDXComponents; },
/* harmony export */   "Zo": function() { return /* binding */ MDXProvider; },
/* harmony export */   "ah": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "pC": function() { return /* binding */ MDXContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,675,6880,5163,9774,2888,179], function() { return __webpack_exec__(1999); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);